import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AdminActions from '../../actions/AdminActions';
import UserForm from '../../components/UserForm.react';
import ImmutablePropTypes from 'react-immutable-proptypes';


export default class NewUser extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  backToAdminOptions() {
    const { router } = this.context;
    router.push('/admin/options');
  }

  handleSubmit(newValue) {
    AdminActions.createUser(
      newValue.email,
      this.props.organization.id,
      newValue.role,
      newValue.tableauUser);
    this.backToAdminOptions();
  }

  render() {
    return (
      <div>
        <h3>New User</h3>
        <UserForm
          availableRoles={this.props.availableRoles}
          availableTableauUsers={this.props.availableTableauUsers}
          defaultTableauUser={this.props.organization.defaultTableauUser}
          onSubmit={this.handleSubmit}
        />
      </div>
    );
  }
}

NewUser.contextTypes = {
  router: PropTypes.object,
};

NewUser.propTypes = {
  organization: PropTypes.shape({
    id: PropTypes.number,
    defaultTableauUser: PropTypes.string,
  }),
  availableRoles: ImmutablePropTypes.iterableOf(
    PropTypes.shape({
      id: PropTypes.number,
      roleClass: PropTypes.string,
    })
  ).isRequired,
  availableTableauUsers: ImmutablePropTypes.iterableOf(
    PropTypes.shape({
      tableauUser: PropTypes.string,
    })
  ).isRequired,
};
